import { createFileRoute, notFound, Outlet } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";

import { myContextQuery } from "@/lib/queries";
import { PanelNotFound } from "@/components/app/panel-not-found";

export const Route = createFileRoute("/_authenticated/t1dwpanel")({
  // Server-side role check for the whole panel subtree. Every child route
  // inherits it, so knowing the URL is not enough to render admin UI.
  // The server function is imported lazily so the route module itself never
  // pulls the server-function middleware chain into the route entry bundle.
  //
  // Non-admins get a plain 404 rather than a redirect: a redirect confirms the
  // path exists and hints at a hidden panel, while a not-found response makes
  // the whole subtree indistinguishable from an unused URL.
  beforeLoad: async () => {
    try {
      const { assertAdminAccess } = await import("@/lib/admin-access.functions");
      await assertAdminAccess();
    } catch (error) {
      if (error && typeof error === "object" && "isRedirect" in error) throw error;
      throw notFound();
    }
  },
  notFoundComponent: PanelNotFound,
  component: AdminLayout,
});

function AdminLayout() {
  const { data: me, isLoading } = useQuery(myContextQuery);

  if (isLoading) {
    return (
      <div className="app-light min-h-screen p-10 text-sm text-muted-foreground">
        Checking access...
      </div>
    );
  }

  if (!me?.isAdmin) {
    return <PanelNotFound />;
  }

  return <Outlet />;
}
